'use strict'

function getImage(image) {
  if (image !== "" && image !== undefined) {
    try {
      return require("@/assets/products/img/" + image.toLowerCase());
    } catch (e) {
      console.warn(
        "module: @/assets/products/img/" + image.toLowerCase() + " not found."
      );
      try {
        return require("@/assets/products/img/global/nophoto.jpg");
      } catch (e) {
        throw "module: @/assets/products/img/global/nophoto.jpg not found.";
      }
    }
  } else {
    try {
      return require("@/assets/products/img/global/nophoto.jpg");
    } catch (e) {
      throw "module: @/assets/products/img/global/nophoto.jpg not found.";
    }
  }
  // end getImage
}

// date function
//
// setDate  : type is string, if null get current date, if date get that date
// format   : 0 = default - iso : YYYY-MM-DD,  1 =  iso : YYYY/MM/DD, 2 =  eu : DD-MM-YYYY, 3 =  eu : DD/MM/YYYY, 
//
function date(format=0, setDate = null) {
  const date = { full: null, day: null, month: null, year: null };
  let rawDate = null;
  if (setDate === null) {
    rawDate = new Date();
  } else {
    rawDate = new Date(setDate);
  }
  date.day = rawDate.getDate();
  date.month = rawDate.getMonth() + 1;
  date.year = rawDate.getFullYear();

  let formatChoice = 0;

  if(typeof(format) === "string"){
    formatChoice = Number(format);
  }
  else{
    formatChoice = format;
  }

  if(formatChoice < 0 ){
    formatChoice = 0;
  } 

  if(formatChoice > 3){
    formatChoice = 3;
  }

  switch(formatChoice){

    case 1 :
      date.full = `${date.year}/${date.month}/${date.day}`;
      break;
    case 2 :
      date.full = `${date.day}-${date.month}-${date.year}`;
      break;
    case 3 :
      date.full = `${date.day}/${date.month}/${date.year}`;
      break;
    default :
      date.full = `${date.year}-${date.month}-${date.day}`;
      break;
  }
  
  return date;
// end date function
}


function time(setTime = null) {
  const time = { full: null, hours: null, minutes: null, seconds: null };
  let rawDate = null;
  if (setTime === null) {
    rawDate = new Date();
  } else {
    rawDate = new Date(setTime);
  }
  time.hours = rawDate.getHours();
  time.minutes = rawDate.getMinutes();
  time.seconds = rawDate.getSeconds();

  let hours = ""

  if(time.hours < 10){
    hours = `0${time.hours}`;
  }
  else{
    hours = time.hours;
  }

  let minutes = "";

  if(time.minutes < 10){
    minutes = `0${time.minutes}`;
  }
  else{
    minutes = time.minutes;
  }

  let seconds = "";

  if(time.seconds < 10){
    seconds = `0${time.seconds}`;
  }
  else{
    seconds = time.seconds;
  }

  time.full = `${hours}:${minutes}:${seconds}`;
  return time;
}


function validateInput(input, type='string', msg){

  const output = {valid:false,reason:''}

  // check input
  // return message
  if(msg === undefined || msg === ""){
    msg = "please enter value";
  }

  // type
  if(type === undefined || type === ""){
    if(type !== 'string' && type !== 'number' && type !== 'boolean' && type !== 'email'){
      type = 'string';
      output.reason = "type fault: parameter 2 is invalid, should be of type boolean, email, number or string.";
    }
  }

  // check input for value
  if(input !== undefined && input !== "" && input !==  msg){
    // if input is not of type email.
    if(type !== 'email'){
      if(type === typeof(input)){
        output.valid = true;
        output.reason = `input true, of type:${type}`;
      }
      else{
        output.reason = `input false, not of type:${type}, is ${typeof(input)}`;
      }
    }
    // if input is email
    else{
      // check if it a string
      if(typeof(input) === "string"){
        // check if the string contains a @
        const emailAddress = input.split("@");
        if(emailAddress.length == 2){
          const emailTag = emailAddress[0]
          // check size of emailTag ( everything before the @ )
          if(emailTag.length > 64){
            output.reason = `input false, local part of email is longer than 64 octets.`;
          } 
          // check the domain
          const domain = emailAddress[1].split(".");
          if(domain.length == 2){
            const hostName = domain[0]
            const hostExtension = domain[1]
            if(hostName.length >= 1 && hostExtension.length >= 2 ){
              output.valid = true;
              output.reason = `input true, of type:email`;
            }
            else if(hostExtension.length < 2){
              output.reason = `input false, domain extenion of email is to short should atleast be 2 didgits.`;
            }
          }
          else{
            output.reason = `input false, domain part of email is incomplete.`;
          }  
        }
        else{
          output.reason = `input false, did not find @ in input string.`;
        }   
      //end if its a string
      }
      // if the input for email is not a string
      else{
        output.reason = `input false, not of type:email, input is not of type string`;
      }
    }
  // end check input value
  }
  return output;
// end validate input 
}

const functions = {
  date,
  time,
  validateInput,
  getImage,
};

export default functions;
